import { defineStore } from "pinia";
import { v4 as uuid } from "uuid";
import defaultLogo from '../assets/glimpse-logo.png'
const MAX_TRY = 3;
const useChatbotStore = defineStore("chatbot", {
  state: () => ({
    loading: false,
    isAudioLoading: false,
    isAudioPlaying: false,
    isChatOpen: false,
    client: null,
    showLogo:false,
    logo:defaultLogo,
    primaryColor:'#3a1a55',
    secondaryColor:'',
    user: null,
    answer: "",
    videoDetails: null,
    maxTries: MAX_TRY,
    userTries: 0,
    messages: [
      // { sender: "bot", text: "How can I help you?", type: "text" },
    ],
  }),
  getters: {
    userDetails: (state) => {
      return state.user;
    },
    isLastTry: (state) => {
      if (state?.user?.email) return false;
      if (!state?.videoDetails?.videoSettings?.isLimitTries) return false;
      return (
        state?.messages?.filter((m) => m?.sender === "bot")?.length >=
        state.maxTries + 1
      );
    },
    isLastUserTry: (state) => {
      if (state?.user?.email) return false;
      if (!state?.videoDetails?.videoSettings?.isLimitTries) return false;
      return state?.userTries - 1 >= state.maxTries;
    },
    lastMessage: (state) => {
      const index = state?.messages?.length - 1;
      if (index !== -1) {
        return state?.messages?.[index];
      }
    },
  },
  actions: {
    setLoading(isLoading) {
      this.loading = isLoading;
    },
    toggleChatUI() {
      this.isChatOpen = !this.isChatOpen;
    },
    setAudioLoading(isLoading) {
      this.isAudioLoading = isLoading;
    },
    setAudioPlaying(isPlaying) {
      this.isAudioPlaying = isPlaying;
    },
    setVideoDetails(data) {
      this.videoDetails = data;
      this.maxTries = data?.videoSettings?.maxTries ?? MAX_TRY;
    },
    setMessage(data, speak = false, messageId = undefined) {
      if (data.sender === "bot" && !this?.user?.email) {
        this.userTries += 1;
      }
      this.messages.push({
        messageId: messageId ?? uuid(),
        speak: speak,
        ...data,
      });
    },
    setAudioMessage(id, data) {
      const index = this.messages.findIndex((m) => m?.messageId === id);
      if (index !== -1) {
        // Create a new object by merging the existing message with the new data
        const updatedMessage = {
          ...this.messages[index],
          howlerInstance: data.howlerInstance,
          wavesurferInstance: data.wavesurferInstance,
          audioUrl: data.audioUrl,
        };

        // Replace the old message with the updated one
        this.messages.splice(index, 1, updatedMessage);
      }
    },
    removePlayAudioFlag(id) {
      if (!id) return;
      const index = this.messages.findIndex((m) => m?.messageId === id);
      if (index !== -1) {
        // Remove the play audio flag
        if (this.messages[index].playAudio) {
          this.messages[index].playAudio = undefined;
        }
      }
    },
    removeMessageById(id) {
      if (!id) return;
      const index = this.messages.findIndex((m) => m?.messageId === id);
      if (index !== -1) {
        // Remove the message at the specified index
        this.messages.splice(index - 1, 2);
      }
    },
    clearMessages() {
      this.messages = [];
    },
    setUser(data) {
      this.user = data;
    },
    increaseTry() {
      this.userTries += 1;
    },
    resetTryCount() {
      this.userTries = 0;
    },
    setClient(data) {
      this.client = data;
      if(data?.siteCustomization?.primaryColor){
        this.primaryColor=data?.siteCustomization?.primaryColor
      }
      if(data?.siteCustomization?.secondaryColor){
        this.secondaryColor=data?.siteCustomization?.secondaryColor
      }
      this.showLogo=data?.siteCustomization?.showLogo
      if(data?.siteCustomization?.showLogo && data?.siteCustomization?.logo){
        this.logo=data?.siteCustomization?.logo
      }
    },
  },
});

export default useChatbotStore;
